import axios from "axios";
const PATH = "api:///v2/campaigns";
const uploadCreative = (campaignId, controllerId, actionId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return axios({
        method: "POST",
        url: `${PATH}/${campaignId}/controllers/${controllerId}/actions/creatives/${actionId}`,
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};
const update = (campaignId, controllerId, actionId, request) => {
    return axios({
        method: "PUT",
        url: `${PATH}/${campaignId}/controllers/${controllerId}/actions/creatives/${actionId}`,
        data: request,
        headers: {
            "Content-Type": "application/json",
        },
    });
};
export default {
    uploadCreative,
    update,
};
